<script lang="ts">
  import { navigate } from "$lib/router.svelte";
  import { auth } from "$lib/stores/auth.svelte";

  let isDemo = $derived(() => sessionStorage.getItem("takite.demo") === "1");

  function createAccount() {
    sessionStorage.removeItem("takite.demo");
    auth.logout().then(() => navigate("/register"));
  }
</script>

{#if isDemo()}
  <div class="sticky top-0 z-40 flex items-center justify-between gap-3 px-4 py-2.5 text-sm font-medium text-white"
       style="background: linear-gradient(90deg, #7c3aed, #2563eb)">
    <span>🎮 Você está no modo demo — os dados são fictícios e reiniciam periodicamente.</span>
    <button
      class="flex-none px-3 py-1 rounded-full text-xs font-bold border border-white/40 hover:bg-white/10 transition-colors whitespace-nowrap"
      onclick={createAccount}
    >
      Criar minha conta →
    </button>
  </div>
{/if}
